import React from 'react';
import { Seed } from './Seed';
const coverage = [{
  label: 'Written in 8-counts',
  body: 'Every step and routine in blocks of eight counts, with a notation key simple enough for a sub to teach cold'
}, {
  label: 'The 3-Level Dial',
  body: 'One step, three settings: kids, beginner and recreational. The count never changes, only what happens on it'
}, {
  label: 'Ready Class Plans',
  body: 'What you do, how you split the group, how you explain it, the common error and its fix, easier and harder options'
}, {
  label: 'Voice cues',
  body: 'A short call-out for each of the 20 most-used steps, so you lead the room without stopping the music'
}, {
  label: 'Music by BPM',
  body: 'Every routine mapped to a tempo range, so you can use any licensed track that fits'
}, {
  label: '30 worksheets',
  body: 'Printable planning sheets, WS-01 to WS-30, to adapt any class to your own group'
}];
const steps = [{
  name: 'Connect',
  time: '3 min',
  tone: 'bg-peach-soft text-peach-deep'
}, {
  name: 'Loosen',
  time: '6 min',
  tone: 'bg-rose-soft text-rose-deep'
}, {
  name: 'Add',
  time: '16 min',
  tone: 'bg-teal-soft text-teal-deep'
}, {
  name: 'Set',
  time: '16 min',
  tone: 'bg-lav-soft text-lav-deep'
}, {
  name: 'Send',
  time: '4 min',
  tone: 'bg-sage-soft text-sage-deep'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="relative w-full overflow-hidden bg-white" data-id="element-243" data-mp="1orawd0ohnhym">
      <Seed className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 opacity-20" data-id="element-244" data-mp="s3ekua7wrcu9" />
      <div className="relative mx-auto max-w-5xl px-5 py-16 text-center sm:py-20" data-id="element-245" data-mp="w4q5s2fu79w4">
        <p className="text-sm font-semibold text-teal-deep" data-id="element-246" data-mp="112i4pgewfw9t">The method</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-247" data-mp="161uofsah4n86">
          The 8-Count Studio System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-navy-soft sm:text-lg" data-id="element-248" data-mp="2ch5639digqen">
          Instead of your own secret shorthand, every class in the pack is
          written the same way: steps in 8-count blocks and every session in
          the same five parts, the{' '}
          <span className="font-semibold text-navy" data-id="element-249" data-mp="1mukl41hossyq">CLASS Anatomy</span>. Only
          the minutes change. So you teach from the page, not from memory, and
          you can turn <span className="font-semibold text-navy" data-id="element-250" data-mp="1wryzlvk1v7oe">any song</span> into a routine the same way.
        </p>

        <ol className="mx-auto mt-9 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-5" data-id="element-251" data-mp="1924p3kn7dv7b">
          {steps.map((step, i) => <li key={step.name} className={`rounded-2xl px-4 py-4 ${step.tone} ${i === steps.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-252" data-mp="1442xgbbponk8" data-mpi={i}>
              <span className="block text-xs font-bold opacity-80" data-id="element-253" data-mp="1e0xqiep7tvr4">Part {i + 1}</span>
              <span className="mt-1 block font-display text-xl" data-id="element-254" data-mp="qbmzvq1kxhqp">{step.name}</span>
              <span className="mt-0.5 block text-xs font-semibold opacity-80" data-id="element-255" data-mp="q9k0wgig8e9u">{step.time}</span>
            </li>)}
        </ol>
        <p className="mt-3 text-xs text-navy-muted" data-id="element-256" data-mp="2wzvot4ujd3jm">Example timing for a 45-minute class. Tables for 30 and 60 minutes included.</p>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-257" data-mp="31sgebu6esuhc">
          {coverage.map(item => <li key={item.label} className="rounded-2xl bg-paper px-4 py-3.5 ring-1 ring-paper-dark" data-id="element-258" data-mp="2mzwizfpi3rag">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-259" data-mp="2rypu51hbf67g">{item.label}</span>
              <span className="mt-1 block text-sm text-navy" data-id="element-260" data-mp="3fok67gtt8qqn">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}